// src/components/RecentBooks.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection, getDocs, query, orderBy, limit as qLimit, doc, getDoc
} from 'firebase/firestore';
import BookCard from './BookCard';

export default function RecentBooks({ limitCount = 8, onlyAvailable = true }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        // 1) пробуємо взяти за createdAtTs (Timestamp)
        const snapTs = await getDocs(
          query(
            collection(db, 'books'),
            orderBy('createdAtTs', 'desc'),
            qLimit(limitCount * 3)
          )
        );

        let docs = snapTs.docs;

        // Якщо колекція ще не має createdAtTs у старих екземплярів — підстрахуємось:
        if (docs.length === 0) {
          const snap = await getDocs(
            query(collection(db, 'books'), qLimit(limitCount * 5))
          );
          docs = snap.docs;
        }

        // 2) збагачуємо даними шаблону + клієнтське сортування
        const rows = [];
        for (const d of docs) {
          const b = d.data();
          if (onlyAvailable && b.status !== 'available') continue;
          if (!b.templateId) continue;

          const tplSnap = await getDoc(doc(db, 'bookTemplates', b.templateId));
          if (!tplSnap.exists()) continue;
          const tpl = tplSnap.data();

          rows.push({
            id: d.id,
            isbn: b.isbn || tpl.isbn || '',
            title: tpl.title,
            author: tpl.author,
            coverUrl: tpl.coverUrl,
            borrowPrice: tpl.borrowPrice,
            borrowCount: tpl.borrowCount,
            // для надійного сортування
            ts: b.createdAtTs?.toMillis?.() ??
                (Date.parse(b.createdAt) || 0),
          });
        }

        rows.sort((a, b) => b.ts - a.ts);
        setItems(rows.slice(0, limitCount));
      } finally {
        setLoading(false);
      }
    })();
  }, [limitCount, onlyAvailable]);

  const [winW, setWinW] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  useEffect(() => {
    const onResize = () => setWinW(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const cols =
    winW <= 540 ? 'repeat(2, minmax(0,1fr))' :
    winW <= 900 ? 'repeat(3, minmax(0,1fr))' :
                  'repeat(4, minmax(0,1fr))';


  if (loading) return null;




  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: cols,
      justifyItems: 'stretch',
      alignItems: 'stretch',
      gap: 16,
      marginBottom: 24,
    }}>
      {items.map(it => (
        <BookCard key={it.id} book={it} />
      ))}
      {items.length === 0 && (
        <div style={{ color: '#6b7280' }}>Ще немає доданих книг.</div>
      )}
    </div>
  );
}
